<div class="toast-container position-fixed p-3 top-0 start-50 translate-middle-x">
    <ng-container *ngFor="let message of toastMessages; let indx = index">
        <div>
            <truelearn-web-toast-message
                #toastMessage
                [message]="message.message"
                [header]="message.header"
                [options]="message.options"
                [hideToast]="message.hide"
                [type]="message.displayType"
                [cssClass]="message.cssClass"
                (hidden)="removeMessage(indx)"
            ></truelearn-web-toast-message>
        </div>
    </ng-container>
</div>
<!-- container to announce toast messages to screen readers, needs to always be in dom -->
<div id="screenReaderAnnouncer" class="visually-hidden" aria-live="polite" aria-atomic="true" role="status">{{
    latestMessage
}}</div>
